module.exports = __webpack_public_path__ + "bopfw.jpg?bddc48e9da215ec886cda2b07ffdad00";